import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FontAwesome__caret-down",
  "use": "FontAwesome__caret-down-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 7\" id=\"FontAwesome__caret-down\"><path fill=\"#66737D\" d=\"m4.185 5.861-3.75-3.75A.948.948 0 0 1 .23 1.086.96.96 0 0 1 1.109.5h7.5a.92.92 0 0 1 .85.586.948.948 0 0 1-.206 1.025l-3.75 3.75a.903.903 0 0 1-1.318 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol